import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LMListContentFilterListUtilService {
  // todo move this stuff into LMListContentFilterListService
  private emitCardDropSource = new Subject<any>();

  cardDropEmitted$ = this.emitCardDropSource.asObservable();

  emitCardDrop(row: number, filterRow: number) {
    this.emitCardDropSource.next({ row, filterRow });
  }
}
